import { json } from '../c-mp/fun/json'
import { getPersonImagesListUrl } from './getPersonImagesListUrl'

export async function fetchPersonImagesList(personId: string) {
	const response = await fetch(getPersonImagesListUrl(personId))
	if (!response.ok) {
		if (response.status === 404) return []
		throw new Error(json`[t9orcf] ${response.status} ${response.statusText}`)
	}
	return response.json() as Promise<string[]>
}
